<template>

    <v-dialog
            v-model="value"
            max-width="500"

    >
        <v-card>
            <!--<v-card-title class="headline"><span v-html="$t('unauthorizedSubscriptionDialog.title')"></span>-->
            <v-card-title class="headline"><span v-html="'Proxy connection failed'"></span>
            </v-card-title>

            <v-card-text style="font-size:16px;">
                        <span >Another VPN is blocking GameEnable from connecting.
                               In order to resolve this issue turn off any other VPN extension or app. </span>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>


                <v-btn
                        color="red darken-1"
                        text
                        @click="close"
                >
                    <span >Close</span>
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<style>


</style>

<script>

    export default {
        name: 'Modal_extensionNotControllable',
        props: ['value'],
        data: () => ({

        }),
      methods: {
          close(){
              this.$emit('input', false);
          }
      }



    };
</script>
